import React from 'react';

import ExternalLink from 'components/Widgets/ExternalLink';
import { useContext as useUsersContext } from 'components/Users/Context';

export default function Terms() {
  const { state: stateUsers } = useUsersContext();

  const affiliate = stateUsers.user.attributes.specific;
  const tosDate = new Date(affiliate.tos_date).toLocaleDateString('en-US');

  return (
    <>
      <h3>Affiliate Terms and Conditions</h3>

      <p>
        The Terms and Conditions have been accepted on
        {' '}
        {tosDate}
        .
      </p>

      <div className="d-flex justify-content-end">
        <ExternalLink
          href="https://www.leggup.com/affiliate-terms-and-conditions"
          variant="outline-primary"
        >
          View Terms
        </ExternalLink>
      </div>
    </>
  );
}
